var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 42
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visa_svg__b",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#231F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#024DA1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "visa_svg__a",
    d: "M39.147 0c-4.752.027-8.091 2.649-8.118 6.393-.032 2.787 2.407 4.34 4.245 5.266 1.888.948 2.521 1.556 2.515 2.403-.015 1.299-1.508 1.87-2.903 1.893-2.437.04-3.852-.68-4.98-1.222l-.877 4.24c1.132.536 3.223 1.004 5.391 1.027 5.094 0 8.425-2.596 8.441-6.619.021-5.105-6.839-5.386-6.792-7.667.015-.694.655-1.431 2.056-1.62.694-.094 2.61-.166 4.78.865l.852-4.102C42.604.426 41.127.01 39.29 0h-.144zm12.801.354c-.931 0-1.716.558-2.063 1.418l-7.276 17.926h5.09l1.012-2.89h6.219l.586 2.89H60L56.086.354h-4.138zm.71 5.226 1.47 7.263h-4.022L52.66 5.58zM24.862.354l-4.01 19.344H25.7L29.709.354H24.86zm-7.173 0-5.046 13.165L10.6 2.325C10.361 1.075 9.415.354 8.364.354H.114L0 .914c1.693.38 3.618.993 4.783 1.647.714.4.917.748 1.152 1.699L9.8 19.698h5.125L22.78.354h-5.092z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.5 11)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "visa_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#visa_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#visa_svg__b)",
    d: "M39.147 0c-4.752.027-8.091 2.649-8.118 6.393-.032 2.787 2.407 4.34 4.245 5.266 1.888.948 2.521 1.556 2.515 2.403-.015 1.299-1.508 1.87-2.903 1.893-2.437.04-3.852-.68-4.98-1.222l-.877 4.24c1.132.536 3.223 1.004 5.391 1.027 5.094 0 8.425-2.596 8.441-6.619.021-5.105-6.839-5.386-6.792-7.667.015-.694.655-1.431 2.056-1.62.694-.094 2.61-.166 4.78.865l.852-4.102C42.604.426 41.127.01 39.29 0h-.144zm12.801.354c-.931 0-1.716.558-2.063 1.418l-7.276 17.926h5.09l1.012-2.89h6.219l.586 2.89H60L56.086.354h-4.138zm.71 5.226 1.47 7.263h-4.022L52.66 5.58zM24.862.354l-4.01 19.344H25.7L29.709.354H24.86zm-7.173 0-5.046 13.165L10.6 2.325C10.361 1.075 9.415.354 8.364.354H.114L0 .914c1.693.38 3.618.993 4.783 1.647.714.4.917.748 1.152 1.699L9.8 19.698h5.125L22.78.354h-5.092z",
    mask: "url(#visa_svg__c)"
  }))));
};
export default SvgVisa;